import { ENVIRONMENT } from '@updater-core/lib/environment';
import { createLogger, getCleanStack } from '@updater-core/lib/logger';
import { track, ERROR } from '@updater-core/lib/tracker';

const { log } = createLogger(
  ENVIRONMENT.debug?.appShell,
  '[DEBUG][APP-SHELL][FADE-TRANSITION]',
  'color: #286d5b'
);

const { log: logRouter } = createLogger(
  ENVIRONMENT.debug?.appShellRouter,
  '[DEBUG][APP-SHELL][ROUTER]',
  'color: #286d5b'
);

export const getRouteConfigForPath = ({ path: pathToSearchFor, routes }) => {
  // TEMP: Log so we can see if unauthenticatedPaths issue is stemming from an invalid go
  logRouter(pathToSearchFor);
  logRouter(getCleanStack());
  return routes.find(({ path }) => pathToSearchFor.match(new RegExp(path)));
};

export const fadeTransition = async ({
  container,
  interactors,
  currentElement,
  currentModule,
  nextElement,
  nextModule,
}) => {
  const ANIMATION_DURATION = 200;

  if (currentModule) {
    // Create and append the next element, but make it
    // invisible to start.
    nextElement.style.transition = `opacity ${ANIMATION_DURATION}ms`;
    nextElement.style.opacity = 0;
    container.appendChild(nextElement);

    container.classList.add('transitioning');

    // Fade out the current element.
    currentElement.style.transition = `opacity ${ANIMATION_DURATION}ms`;
    currentElement.style.opacity = 0;

    // Wait for current element to fade out.
    await new Promise((resolve) => setTimeout(resolve, ANIMATION_DURATION));

    // Unmount the current module.
    await Promise.resolve(
      currentModule.unmount({ container: currentElement, interactors })
    );

    // Remove the current element.
    currentElement.remove();

    // Mount the next module.
    log('mounting next module');
    await Promise.resolve(
      nextModule.mount({ container: nextElement, interactors })
    );

    log('showing next module');
    // Fade in the next element.
    nextElement.style.opacity = 1;

    container.classList.remove('transitioning');
  } else {
    container.appendChild(nextElement);

    await Promise.resolve(
      nextModule.mount({ container: nextElement, interactors })
    );
  }
};

// Enqueue accepts an async function and returns a function which produces the
// same result, but ensures that subsequent calls to this function don’t call
// the underlying function until all previous calls have resolved.
export const enqueue = (fn) => {
  const queue = [];

  return (...args) => {
    const wait = Promise.all(queue);
    const promise = new Promise((resolve) =>
      wait.then(() => {
        // fn is only called when all previous function calls have resolved
        resolve(fn(...args));
      })
    );
    queue.push(promise);
    return promise
      .then((result) => {
        // Using splice for safety, but shift should work since all previous
        // promises should have resolved
        queue.splice(queue.indexOf(promise), 1);
        return result;
      })
      .catch((e) => {
        queue.splice(queue.indexOf(promise), 1);
        console.error('Error in route transition', e);
        if (e) {
          track({
            domain: 'mover',
            verb: ERROR,
            object: 'route_go',
            details: {
              error: e,
              ...e,
            },
          });
        }
      });
  };
};
